import { NIcon } from '@innersource-nn/novoui-react';
import React, { useState } from 'react';

interface CardProps {
    icon: React.ReactNode;
    content: React.ReactNode;
    title: string;
    secondaryTitle?: string;
    defaultOpen?: boolean;
}

const ExpandableCard = ({
    icon,
    content,
    title,
    secondaryTitle,
    defaultOpen,
}: CardProps) => {
    const [open, setOpen] = useState(defaultOpen || false);
    return (
        <div className="bg-white p-16 border-1 border-faded-blue-400 w-full rounded-8 text-true-blue">
            <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => setOpen(!open)}
            >
                <div className="flex justify-start items-center gap-16">
                    {icon}
                    <b>{title}</b>
                    {secondaryTitle}
                </div>
                <NIcon
                    iconName={open ? 'chevronUp' : 'chevronDown'}
                    size={20}
                    className="fill-true-blue"
                />
            </div>

            <div
                className={`overflow-hidden transition-all ${
                    open ? 'h-auto' : 'h-0'
                }`}
            >
                {content}
            </div>
        </div>
    );
};

export default ExpandableCard;
